import axios from "axios";
import { message } from "antd";

const http = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    "Content-type": "application/json",
  },
});

const navigateToLogin = () => {
  localStorage.clear();
  window.location.href = "/";
};

// let isTokenExpiredHandled = false;

http.interceptors.request.use(
  (config) => {
    let token = localStorage.getItem("access_token");
    config.headers["Authorization"] = `Bearer ${token}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

let isRefreshing = false;
let failedQueue = [];
let hasShownSessionExpiredMessage = false;

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

http.interceptors.response.use((response) => response, async (error) => {
  const originalRequest = error.config;

  if (error.response?.status === 401 && !originalRequest._retry) {
    originalRequest._retry = true;

    const refreshToken = localStorage.getItem('refresh_token');

    if (!isRefreshing) {
      isRefreshing = true;

      try {
        const response = await http.get(`/oauth/new/token?refreshToken=${refreshToken}`);
        if (response?.data?.error === "1") {
          processQueue(response.data, null);
          isRefreshing = false;

          if (!hasShownSessionExpiredMessage) {
            hasShownSessionExpiredMessage = true;
            message.warning({
              content: "Your session has ended. Please log in again to continue.",
              onClose: navigateToLogin,
            });
          }
          return Promise.reject(response.data);
        }
        const newToken = response?.data?.access_token;

        localStorage.setItem('access_token', newToken);
        http.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
        processQueue(null, newToken);
        isRefreshing = false;

        // Retry the original request with new token
        originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
        return http(originalRequest);
      } catch (err) {
        processQueue(err, null);
        isRefreshing = false;

        message.warning({
          content: "Your session has ended. Please log in again to continue.",
          onClose: navigateToLogin,
        });
        return Promise.reject(err);
      }
    }

    return new Promise(function (resolve, reject) {
      failedQueue.push({
        resolve: (token) => {
          originalRequest.headers['Authorization'] = 'Bearer ' + token;
          resolve(http(originalRequest));
        },
        reject: (err) => {
          reject(err);
        }
      });
    });
  }

  return Promise.reject(error);
}
);

export default http;